import type { SiteRendererProps } from './registry';

export function FallbackSite({ content, domain }: SiteRendererProps) {
  const businessName =
    (content.contact?.businessName as string | undefined) ??
    (content.hero?.title as string | undefined) ??
    domain;

  const subtitle = content.hero?.subtitle as string | undefined;
  const phone = content.contact?.phone as string | undefined;
  const address = content.contact?.address as string | undefined;

  return (
    <main
      style={{
        minHeight: '100vh',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        background: '#0f172a',
        color: '#f8fafc',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <div style={{ maxWidth: 640, textAlign: 'center' }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: '1rem' }}>
          {businessName}
        </h1>
        {subtitle && (
          <p style={{ fontSize: '1.125rem', color: '#cbd5e1', marginBottom: '2rem' }}>
            {subtitle}
          </p>
        )}
        {phone && (
          <p style={{ fontSize: '1rem', marginBottom: '0.5rem' }}>
            <a href={`tel:${phone}`} style={{ color: '#38bdf8' }}>
              {phone}
            </a>
          </p>
        )}
        {address && <p style={{ fontSize: '0.95rem', color: '#94a3b8' }}>{address}</p>}
      </div>
    </main>
  );
}
